module.exports = __webpack_public_path__ + "img/067.ba359ab0.png";